import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../models/api-response.model';
import { AuthUser } from '../models/user.model';

export interface UserAuthInterface {
  readonly authenticatedUser: AuthUser | null;
  login(userName: string, password: string): Observable<ApiResponse<AuthUser>>;
  setAuthenticatedUser(user: AuthUser, rememberMe: boolean): void;
  clearSession(): void;
  hasPermission(permission: string): boolean;
}
export const USER_AUTHENTICATION_SERVICE = new InjectionToken<UserAuthInterface>('lucky draw authentication service');
